var unitSwitches = document.querySelectorAll('[data-unit-switch-checkbox]')

 
for (var i = 0; i < unitSwitches.length; i++){
    var unitSwitch = unitSwitches[i]

    unitSwitch.addEventListener('change', function(e){
        var untiSwitchValuesMetric = document.querySelectorAll('[data-unit-switch-value="metric"]')
        var untiSwitchValuesImperial = document.querySelectorAll('[data-unit-switch-value="imperial"]')
        var unitSwitchAlterText = document.querySelectorAll('[data-unit-switch-alter-text]')

        if (this.checked) {
            localStorage.setItem("ESC_UNITS", 'imperial')
            for (var j = 0; j < untiSwitchValuesMetric.length; j++) {
                untiSwitchValuesMetric[j].classList.add('hide')
            }
            for (var j = 0; j < untiSwitchValuesImperial.length; j++) {
                untiSwitchValuesImperial[j].classList.remove('hide')
            }
            for (var j = 0; j < unitSwitchAlterText.length; j++) {
                var imperialText = unitSwitchAlterText[j].dataset.imperial
                unitSwitchAlterText[j].innerHTML = imperialText
            }
        } else {
            localStorage.setItem("ESC_UNITS", 'metric')
            for (var j = 0; j < untiSwitchValuesMetric.length; j++) {
                untiSwitchValuesMetric[j].classList.remove('hide')
            }
            for (var j = 0; j < untiSwitchValuesImperial.length; j++) {
                untiSwitchValuesImperial[j].classList.add('hide')
            }
            for (var j = 0; j < unitSwitchAlterText.length; j++) {
                var imperialText = unitSwitchAlterText[j].dataset.metric
                unitSwitchAlterText[j].innerHTML = imperialText
            }
        }

    })

    if (localStorage.getItem('ESC_UNITS') && localStorage.getItem('ESC_UNITS') === 'imperial') {
        unitSwitch.checked = true
        unitSwitch.dispatchEvent(new Event('change'))
    }
}
